import type { ReportOptions } from "./result"

interface Reporter {
  reportError(e: unknown, options: ReportOptions): void
}

let reporter: Reporter | undefined

export function setReporter(r: Reporter) {
  if (reporter) {
    throw new Error("Cannot set reporter twice")
  }

  reporter = r
}

export function getReporter() {
  if (!reporter) {
    throw new Error("Reporter must be set")
  }

  return reporter
}
